import { LocationsView } from "@/admin/locations/LocationsView.tsx";
import { createLazyFileRoute } from "@tanstack/react-router";

export const Route = createLazyFileRoute("/admin/_menu/_simple/locations")({
    component: LocationsView,
});
